import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";
import InterfaceProperties from "../../../components/Interface/InterfaceProperties";
import InterfaceCompatibility from "../../../components/Interface/InterfaceCompatibility";

class Component_record_keywords extends PureComponent {
  render() {
    return (
      <div className="row" id="component_record_keywords">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Record Keywords</h2>
              <p>
                Keywords are a simple yet powerful way of sorting your records.
                The keyword component allows the users to add multiple keywords
                or tags against a record which can later be used for reporting
                or analysis. Keywords can be set up either by administrators or
                with the correct permissions; with the correct permissions,
                users can create their own mid-operation. Keywords support icons
                and colors as well as keyword groupings.
              </p>

              <InterfaceCompatibility
                dashboard={false}
                record={true}
                report={false}
                search={false}
              />
              <InterfaceProperties
                type={"record_keywords"}
                name={"keyword"}
                dataNameDefault={'"array_text_my_field"'}
                autoFill={'["value1", "value2"]'}
                padding={true}
                hide={true}
                order={true}
                button={false}
                tabIndex={true}
                readOnly={true}
                displayName={true}
                onChangeEval={true}
                sourceUrl={true}
                properties={[
                  {
                    property: "keyword_add",
                    description: "Allows the user to enter a new keyword.",
                    defaults: "true, false default is false"
                  },
                  {
                    property: "keyword_add_to_db",
                    description:
                      "Adds newly created keywords to the database assuming the user has permission.",
                    defaults: "true, false default is false"
                  },
                  {
                    property: "keyword_db_size",
                    description:
                      "	Sets the size of the database get keywords. Default is 500",
                    defaults: "1 - 10000, default is 500"
                  },
                  {
                    property: "keyword_max",
                    description: "Maximum number of keywords a user can enter.",
                    defaults: "1-20"
                  },
                  {
                    property: "source_option_name",
                    description:
                      "Display name of keyword when using custom source_url_api.",
                    defaults: '"text_name", default is ""'
                  },
                  {
                    property: "source_option_value",
                    description:
                      "Value stored in database when using custom source_url_api.",
                    defaults: '"text_name", "id", default is "id"'
                  },
                  {
                    property: "display_default_icon",
                    description:
                      "Default icon used for custom source_url_api items.",
                    defaults: '"android", "cloud", default is "help"'
                  },
                  {
                    property: "display_default_icon_backcolor",
                    description:
                      "Default icon background color used for custom source_url_api items.",
                    defaults: '"#0D47A1", "#D50000", default is "#9E9E9E"'
                  },
                  {
                    property: "display_default_icon_forecolor",
                    description:
                      "Default icon foreground color used for custom source_url_api items.",
                    defaults: '"#E3F2FD", "#FFEBEE", default is "#ffffff"'
                  }

                ]}
              />
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Record Keywords Example</h2>
            </section>
            <section>
              <h3>Example 1: Simple Keywords</h3>
              <div className="darkCode">
                <div>&#123;</div>
                <strong>
                  <div className="i1">
                    <span className="jsonG">"type"</span>:{" "}
                    <span className="jsonY">"record_keywords"</span>,
                  </div>
                </strong>
                <div className="i1">
                  <span className="jsonG">"data_name"</span>:{" "}
                  <span className="jsonY">"array_text_my_field"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"display_name"</span>:{" "}
                  <span className="jsonY">"My Field"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"keyword_add"</span>:{" "}
                  <span className="jsonP">true</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"keyword_max"</span>:{" "}
                  <span className="jsonP">8</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"keyword_group"</span>:{" "}
                  <span className="jsonY">"ict"</span>
                </div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Component_record_keywords;



// WEBPACK FOOTER //
// ./src/components/knowlege/interface/Component_record_keywords.js